const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const AT = require("../../core/vault/ActionTypes");
const Input = require("./Input");
const styles = require("./styles/ContactInfo.css");
const Checkbox = require("../../core/view/Checkbox");
const CopyTable = require("../data/CopyTable");
const {track} = require("../../core/util/Mixpanel");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "ContactInfo",

		propTypes: {
			contactInfo: PT.object.isRequired,
			subscribeOnCheckout: PT.bool.isRequired,
			errorFields: PT.object.isRequired,
			initialTabIndex: PT.number.isRequired,
			showParts: PT.array,
			contentOnly: PT.bool,
			style: PT.object,
			setCheckedToDefault: PT.bool,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		updateField: function(field, val) {
			this.props.dispatch({
				type: AT.UPDATE_CART_FORMDATA,
				section: "contact",
				vals: {[field]: val},
			});
		},

		// calculate and then fill in the default subscribe info
		updateDefaultSubscribe: function() {
			if (this.props.setCheckedToDefault) {
				this.props.dispatch({
					type: AT.UPDATE_DEFAULT_CART_SUBSCRIBE_EMAIL,
				});
			}
		},

		userUpdateSubscribe: function(val) {
			track(`User ${val ? "Opted In to" : "Opted Out of"} Marketing Emails`, {
				optIn: val,
			});
			this.props.dispatch({
				type: AT.USER_UPDATE_CART_SUBSCRIBE_EMAIL,
				val,
			});
		},

		componentDidMount: function() {
			this.updateDefaultSubscribe();
		},

		render: function() {
			const {contactInfo, errorFields, showParts} = this.props;

			let showPhone, showEmail, showCheckbox, showYourEmail;
			if (!showParts) {
				showPhone = true;
				showEmail = true;
				showCheckbox = true;
			} else {
				// showparts given, so conditionally render. make sure it's a valid array for confidence
				showPhone = showParts.includes("phone");
				showEmail = showParts.includes("email");
				showYourEmail = showParts.includes("your email");
				showCheckbox = showParts.includes("checkbox");
			}

			const phoneError = _.get(
				errorFields,
				["errorTypes", "phone", "type"],
				""
			);
			const emailError = _.get(
				errorFields,
				["errorTypes", "email", "type"],
				""
			);

			const subscribeCopy = CopyTable.getCheckoutSubscribeCopy(
				"billing-contact"
			);

			// Name and autocomplete are from
			// https://developers.google.com/web/fundamentals/design-and-ui/input/forms/
			return (
				<div>
					{showPhone && (
						<Input
							className={styles.row}
							nameAttr="phone"
							autocompleteAttr="section-contact tel"
							autofocus={true}
							onUpdate={val => this.updateField("phone", val)}
							initialValue={contactInfo.phone}
							placeholder={"Phone Number"}
							checkType={"phone"}
							showErrorType={phoneError}
							tabIndex={this.props.initialTabIndex}
							maxLength={64}
						/>
					)}
					{(showEmail || showYourEmail) && (
						<Input
							className={styles.row}
							nameAttr="email"
							autocompleteAttr="section-contact email"
							onUpdate={val => this.updateField("email", val)}
							initialValue={contactInfo.email}
							placeholder={showYourEmail ? "Your Email" : "Email"}
							checkType={"email"}
							showErrorType={emailError}
							tabIndex={this.props.initialTabIndex + 1}
							maxLength={100}
						/>
					)}

					{showCheckbox && (
						<Checkbox
							className={styles.subscribeCheck}
							text={subscribeCopy}
							onClick={this.userUpdateSubscribe}
							isSelected={this.props.subscribeOnCheckout}
							tabIndex={this.props.initialTabIndex + 2}
						/>
					)}
				</div>
			);
		},
	})
);
